import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Chinese() {
  return (
    <ApiCommunityDirectoryPage
      community="Chinese"
      eyebrow="Chinese community guide"
      title="Chinese favorites, businesses, and local essentials in San Antonio."
      
      tags={["Chinese community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Chinese community guide?"
      modalIdPrefix="chinese-directory"
    />
  );
}
